import React from 'react';
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import CommentSection from '../comment-section/comment-section';
import LikeButton from '../../molecules/like-button/like-button';
import { CONTENT_TYPE_ARTICULO } from "../../../services/social.services";

// Styles //
import "./forumPage.scss";

const ForumPage = (props: ReferenciaContenido) => {
    return (
        <>
            <div className="o-forum-page_top">
                <div className="o-forum-page_top__likes">
                    <LikeButton contentId={props.parentContentfulId} contentType={CONTENT_TYPE_ARTICULO}/>
                    <hr/>
                </div>
            </div>
            <div className="o-forum-page_middle">
                <CommentSection contentId={props.parentContentfulId}>
                </CommentSection>
            </div>
        </>
    )
}

export default ForumPage;